import { render, staticRenderFns } from "./placard_invoice.vue?vue&type=template&id=3c4737a9&scoped=true"
import script from "./placard_invoice.vue?vue&type=script&lang=js"
export * from "./placard_invoice.vue?vue&type=script&lang=js"
import style0 from "./placard_invoice.vue?vue&type=style&index=0&id=3c4737a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4737a9",
  null
  
)

export default component.exports